import React, { PureComponent } from "react";

import styles from "./Media.local.scss";

export default class MediaFetchingComponent extends PureComponent {
  render() {
    return <div className={styles.media} />;
  }
}

// Conn



// WEBPACK FOOTER //
// ./src/components/Common/MediaFetching/MediaFetchingComponent.js